<template>
  <div class="dashboard-widget-testimonials">
    <div class="inner-box">
      <div class="dashboard-widget-testimonials-slider-wrapper" @mouseenter="stopSlider" @mouseleave="startSlider">
        <div
          class="testimonials"
          :style="{
            transform: `translateX(-${slider_current_index * (100 / items_per_slide)}%)`,
            transition: isResetting ? 'none' : 'transform 0.5s ease'
          }"
          @transitionend="handleTransitionEnd"
        >
          <div
            class="testimonial"
            v-for="(item, idx) in clonedTestimonials"
            :key="`testimonial_${idx}`"
          >
            <img :src="`/images/testimonial_0${item}.png`">
          </div>
        </div>
      </div>
      <div class="slider-nav mt-3 mb-3">
        <div
          v-for="(_, idx) in testimonials"
          :key="`testimonial_nav_${idx}`"
          class="slider-nav-item"
          :class="{ active: idx === realIndex }"
          @click="goToSlide(idx)"
        ></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      testimonials: [1, 2, 3, 4, 5, 6],
      slider_current_index: 0,
      realIndex: 0,
      slider_timer: null,
      items_per_slide: 3,
      isTransitioning: false,
      isResetting: false,
    };
  },
  computed: {
    clonedTestimonials() {
      return [
        ...this.testimonials.slice(-this.items_per_slide),
        ...this.testimonials,
        ...this.testimonials.slice(0, this.items_per_slide)
      ];
    },
    totalSlides() {
      return this.testimonials.length;
    }
  },
  mounted() {
    this.slider_current_index = this.items_per_slide;
    this.startSlider();
  },
  methods: {
    startSlider() {
      this.stopSlider();
      this.slider_timer = setInterval(() => {
        this.nextSlide();
      }, 5000);
    },
    stopSlider() {
      if (this.slider_timer) {
        clearInterval(this.slider_timer);
        this.slider_timer = null;
      }
    },
    nextSlide() {
      if (this.isTransitioning) return;
      this.isTransitioning = true;
      this.slider_current_index++;

      setTimeout(() => {
        if (this.slider_current_index >= this.totalSlides + this.items_per_slide) {
          this.isResetting = true;
          this.slider_current_index = this.items_per_slide;
          setTimeout(() => (this.isResetting = false), 50);
        }
        this.updateRealIndex();
      }, 500);
    },
    goToSlide(index) {
      if (this.isTransitioning) return;
      this.isTransitioning = true;
      this.realIndex = index;
      this.slider_current_index = index + this.items_per_slide;
    },
    handleTransitionEnd() {
      this.isTransitioning = false;

      if (this.slider_current_index >= this.totalSlides + this.items_per_slide) {
        this.isResetting = true;
        this.slider_current_index = this.items_per_slide;
        setTimeout(() => (this.isResetting = false), 50);
      } else if (this.slider_current_index < this.items_per_slide) {
        this.isResetting = true;
        this.slider_current_index = this.totalSlides + this.items_per_slide - 1;
        setTimeout(() => (this.isResetting = false), 50);
      }

      this.updateRealIndex();
    },
    updateRealIndex() {
      this.realIndex =
        (this.slider_current_index - this.items_per_slide + this.totalSlides) %
        this.totalSlides;
    }
  }
};
</script>
